/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.insights.ModelAliasScope
*/
export var ModelAliasScope;
(function (ModelAliasScope) {
    ModelAliasScope["TENANT"] = "TENANT";
    ModelAliasScope["PROJECT"] = "PROJECT";
})(ModelAliasScope || (ModelAliasScope = {}));
//# sourceMappingURL=ModelAliasScope.js.map